export default {
  layouts: {
    auth: {
      becomePartner: 'Партнер',
      support: 'Есть вопросы? Позвоните нам:',
    },
  },
};
